<script>
import ChatUserTrucks from "@/components/user/UserTrucks.vue";
import UserCard from "@/components/user/UserCard.vue";

export default {
  name: "ChatInfoCoordinatorPanel",
  components: { UserCard, ChatUserTrucks },
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      trucks: {},
      loadingTrucks: false,
    };
  },
  watch: {
    async user() {
      await this.loadCoordinatedTrucks();
    },
  },
  async mounted() {
    await this.loadCoordinatedTrucks();
  },
  methods: {
    async loadCoordinatedTrucks() {
      if (!this.user.isCoordinator) {
        return;
      }

      this.loadingTrucks = true;
      const resp = await this.$api.trucks.findTrucks({ contactPerson: this.user.id, pageSize: 100 }, false);
      if (resp.success) {
        this.trucks = Object.groupBy(resp.data.items, ({ ownerId }) => ownerId);
      }
      this.loadingTrucks = false;
    },
  },
};
</script>

<template>
  <div v-if="user.isCoordinator" class="panel-info__block rounded" data-qa="coordinator-info-block">
    <div
      class="panel-info__block-header d-flex justify-space-between bg-blue-lighten-2 pt-2 pb-2 pl-5 pr-5 rounded-b-0 rounded"
    >
      <span class="font-size-12 font-weight-600 text-uppercase text-white">Coordinator</span>
    </div>

    <template v-if="!loadingTrucks">
      <div v-for="(coordinator, index) in user.owners" :key="index" class="panel-info__block-content pa-3">
        <user-card
          :role="$t('drivers.owner')"
          :status="coordinator.owner.ownerStatus"
          :user="coordinator.owner"
          role-color="text-green-lighten-1"
        />
        <chat-user-trucks :initial-trucks="trucks[coordinator.ownerId] || []" :user="coordinator.user" />
        <div v-if="index < user.owners.length - 1" class="short-line" />
      </div>
    </template>
  </div>
</template>

<style scoped>
.panel-info__block {
  margin-bottom: 16px;
  background: #f8f9fa;
  border-bottom: none;
}
</style>
